// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"364":"7b26068b","587":"3300183a","695":"8abef5a1","920":"1dd91163","921":"bfae9849","958":"b172491a"}[chunkId] + ".css";
};